export function initHeaderShare() {
    if (window.Ya) {
        Ya.share2($('#header-share')[0], {
            theme: {
                bare: true,
                copy: 'hidden',
                services: 'vkontakte,odnoklassniki,facebook',
            },
            content: {
                title: $('title').text(),
                url: window.siteUrl + window.pollLink,
            },
        })
    }
}